import PrimaryCTA from './PrimaryCTA';
import withValidation from '../../../../../shared/components/withValidation';

// Primary CTA is valid when learn more is valid
const validate = isValid => isValid;

const validateOnMount = (props, { isValid }) => validate(isValid);

export default withValidation(PrimaryCTA, validate, validateOnMount);
